import { color } from "../resource";
export const STATUS_CREDIT = {
  APPROVED: {
    label: "อนุมัติแล้ว",
    color: color["success"],
  },
  REJECTED: {
    label: "ไม่อนุมัติ",
    color: color["error"],
  },
  AUTO_REJECTED: {
    label: "ไม่อนุมัติ (อัตโนมัติ)",
    color: color["error"],
  },
  WAITING: {
    label: "รออนุมัติ",
    color: color["warning"],
  },
  PENDING: {
    label: "รออนุมัติ",
    color: color["warning"],
  },
  true: {
    label: "เปิดใช้งาน",
    color: color["primary"],
  },
  false: {
    label: "ปิดใช้งาน",
    color: color["background4"],
  },
};
export type NormalizedStatus = "WAITING" | "APPROVED" | "REJECTED" | "PENDING" | "AUTO_REJECTED";

export const normalizeStatus = (rawStatus?: string): NormalizedStatus => {
  if (!rawStatus) return "PENDING";

  const status = rawStatus.toUpperCase().trim();

  if (/^APPROV/.test(status)) return "APPROVED";
  if (/^REJECT/.test(status)) return "REJECTED";
  if (/^WAIT/.test(status)) return "WAITING";
  if (/^PEND|PROGRESS|PROCESS/.test(status)) return "PENDING";
  if (/^AUTO_REJECT/.test(status)) return "AUTO_REJECTED";

  return "PENDING";
};
